import { Component, Input } from '@angular/core';

@Component({
  selector: 'rl-loading-banner',
  templateUrl: './loading-banner.component.html',
  styleUrls: ['./loading-banner.component.scss'],
})
export class LoadingBannerComponent {
  @Input() isLoading: boolean;
}
